module.exports = __webpack_public_path__ + "static/media/civic_watch_logo-transparent.ec2ac927.png";